/* eslint-disable react/no-array-index-key */

import { Radio, RadioGroup } from '@mui/material';
import {
  Merchandise,
  SplitLine,
  Tag,
  ItemList, WrongInfo,
} from '@components';
import { ShipmentStatus, NEED_TO_ADD_TRACKING_NUMBER } from '@constants';
import { useNavigate } from 'react-router-dom';
import { RemarkPanel } from '@/components/choose/remark-panel';
import classes from '../choose/index.module.css';

const HAS_CLAIME_TEXT = 'This item already has a reported issue.';

export const PackageRadioGroup = ({
  packageList, onChange, delayPackageId, onClickTitle, specialPlatform, handleShippingClick,
}) => {
  const navigate = useNavigate();

  const handleItemClick = (item) => {
    navigate(`../feedback?claimId=${item.claimId}`);
  };

  const isNeedToVerfyTracking = NEED_TO_ADD_TRACKING_NUMBER.includes(specialPlatform);
  return (
    <RadioGroup>
      {packageList.map((packageItem, packageIndex) => (
        <div key={packageItem.fulfillmentId}>
          {packageIndex === 0 ? null : <SplitLine />}
          <section className={classes.radio_line}>
            <Radio
              color="input"
              onChange={(v) => onChange(v, packageItem)}
              value={packageItem.fulfillmentId}
              style={{
                padding: '0PX',
                marginRight: '8PX',
              }}
              checked={packageItem.fulfillmentId === delayPackageId}
              disabled={!!packageItem?.items[0]?.claimId || packageItem.items?.filter((item) => (item.isInEffectivePeriod === false || (isNeedToVerfyTracking && !item.trackingNumber)))?.length > 0}
            />
            <span onClick={() => onClickTitle(packageItem)} className={classes.order_name}>
              <span className={classes.order_name_title}>Order</span>
              {`${packageItem.fulfillmentName}`}
            </span>
            {packageItem.status !== ShipmentStatus.Unknown && (
              <Tag
                color={packageItem.status === ShipmentStatus.Delivered ? '#AEE9D1' : '#E4E5E7'}
                text={packageItem.status === ShipmentStatus.Delivered ? 'Delivered' : 'Undelivered'}
              />
            )}
            {!packageItem.trackingNumber && isNeedToVerfyTracking && <div className={classes.add_shipping} onClick={() => handleShippingClick(packageItem.fulfillmentId)}>Add Shipping Information</div>}
            {
              [ShipmentStatus.UnDelivered, ShipmentStatus.unDelivered].includes(packageItem.status) ? (
                <WrongInfo name={packageItem.fulfillmentName} status={packageItem.status} />
              ) : null
            }
          </section>
          {/* 根据接口返回字段判断是否可选并提示文案 */}
          {(packageItem.items?.filter((item) => item.isInEffectivePeriod === false)?.length > 0) && (
            <div className={classes.warning_tips_wrapper}>
              <div className={classes.warning_tips}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <g clipPath="url(#clip0_15292_32678)">
                    <path fillRule="evenodd" clipRule="evenodd" d="M8 0C3.5888 0 0 3.5888 0 8C0 12.4112 3.5888 16 8 16C12.4112 16 16 12.4112 16 8C16 3.5888 12.4112 0 8 0ZM7.2 4.8C7.2 4.35817 7.55817 4 8 4C8.44183 4 8.8 4.35817 8.8 4.8V8C8.8 8.44183 8.44183 8.8 8 8.8C7.55817 8.8 7.2 8.44183 7.2 8V4.8ZM8 12C8.44183 12 8.8 11.6418 8.8 11.2C8.8 10.7582 8.44183 10.4 8 10.4C7.55817 10.4 7.2 10.7582 7.2 11.2C7.2 11.6418 7.55817 12 8 12Z" fill="#FC9952" />
                  </g>
                  <defs>
                    <clipPath id="clip0_15292_32678">
                      <rect width="16" height="16" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                This package is not yet eligible to file a shipping delay claim.
              </div>
            </div>
          )}
          {packageItem.items.map(((item, index) => (
            <ItemList
              key={`${item.lineItemId}_${index}`}
              item={item}
              itemKey={`${item.lineItemId}_${index}`}
              index={index}
            >
              <div>
                <Merchandise item={item}>
                  {item.claimId
                    ? (
                      <RemarkPanel
                        title={HAS_CLAIME_TEXT}
                        btnText="View issue &gt; "
                        isShow={false}
                        onClick={() => handleItemClick(item)}
                      />
                    )

                    : null}
                </Merchandise>
              </div>
            </ItemList>
          )))}
        </div>
      ))}
    </RadioGroup>
  );
};
